const initialState = {
  reservations: { data: [] },
  foods: { data: [] },
};

export const reservation_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_RESERVATION":
      return {
        ...state,
        reservations: action.payload,
      };
    case "GET_FOODS":
      return {
        ...state,
        foods: action.payload,
      };
    default:
      return state;
  }
};
